<template>
    <div>
        <b-modal
            size="lg"
            title="Add New Store"
            ref="AddStore"
            @hidden="cancelAddStore"
            @shown="getmap">
            <div id="add-store" class="modal-form">
                <b-row no-gutters>
                    <b-col sm="12" md="3">
                        <h6 class="main-label">Store</h6>
                    </b-col>
                    <b-col>
                        <b-form-group id="nameGroup"
                            label="Name"
                            label-for="name"
                            class="secondary-label mb-3 sl-helper"
                            :invalid-feedback="errorMessage('store_name')"
                            :state="isValid('store_name')">
                            <b-form-input id="name"
                                type="text"
                                maxlength="25"
                                required
                                v-model="store.name">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group id="typeGroup"
                            label="Type"
                            label-for="type"
                            class="secondary-label mb-3 sl-helper"
                            :invalid-feedback="errorMessage('store_type')"
                            :state="isValid('store_type')">
                            <b-form-input id="type"
                                type="text"
                                maxlength="25"
                                required
                                v-model="store.type">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group id="tierGroup"
                            label="Tier"
                            label-for="tier"
                            class="secondary-label mb-3 sl-helper"
                            :invalid-feedback="errorMessage('tier')"
                            :state="isValid('tier')">
                            <b-form-input id="tier"
                                type="text"
                                maxlength="25"
                                required
                                v-model="store.tier">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group id="isrGroup"
                            label="ISR Code"
                            label-for="isr_code"
                            class="secondary-label mb-3 sl-helper"
                            :invalid-feedback="errorMessage('isr_code')"
                            :state="isValid('isr_code')">
                            <b-form-input id="isr_code"
                                type="text"
                                maxlength="25"
                                required
                                v-model="store.isr_code">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group id="retailerDate"
                            label="Retailer Since"
                            label-for="store.retailer_since"
                            class="secondary-label mb-3 sl-helper"
                            :invalid-feedback="errorMessage('retailer_since')"
                            :state="isValid('retailer_since')">
                            <div id="custom-datepicker">
                                <b-input-group class="custom-datepicker mb-1 muli-sb d-flex shadow-none">
                                    <b-input-group-text slot="append" class="bg-transparent">
                                        <img src="../../../assets/images/icons/calendar.svg" alt="Calendar Icon" class="form-icon action-button"
                                            @click="openCalendar('start')">
                                    </b-input-group-text>
                                    <SingleDatepicker :bootstrap-styling="true"
                                        :value="store.retailer_since"
                                        ref="datepicker_start"
                                        v-model="store.retailer_since"
                                        wrapper-class="custom-datepicker"
                                        style="color: #2a2a2a !important;"
                                        :disabledDates="disabledDates"
                                    />
                                </b-input-group>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col>
                        <hr class="form-divider">
                    </b-col>
                </b-row>
                <b-row no-gutters>
                    <b-col sm="12" md="3">
                        <h6 class="main-label">Thumbnail</h6>
                        <span class="label-helper d-inline-block">(200 x 200)</span>
                    </b-col>
                    <b-col>
                        <b-form-group
                            label="Upload Image"
                            label-for="store.image"
                            class="secondary-label mb-3 sl-helper"
                            :invalid-feedback="errorMessage('store_image')"
                            :state="isValid('store_image')">
                            <div id="store-img"
                                class="border rounded position-relative"
                                @click="uploadLogo('new')">
                                <!-- Use an if else here for showing an image -->
                                <img v-if="store.image !== ''" :src="store.image" alt="Sample Image">
                                <div class="upload-icon rounded-circle border">
                                </div>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col>
                        <hr class="form-divider">
                    </b-col>
                </b-row>
                <b-row no-gutters>
                    <b-col sm="12" md="3">
                        <h6 class="main-label">Contact</h6>
                    </b-col>
                    <b-col>
                        <b-form-group id="contactGroup"
                            label="Mobile No."
                            label-for="mobile"
                            class="secondary-label mb-3 sl-helper"
                            :invalid-feedback="errorMessage('phone')"
                            :state="isValid('phone')">
                            <!-- <b-input-group prepend="+63" class="shadow-none"> -->
                                <b-form-input id="mobile"
                                    type="text"
                                    required
                                    v-model="store.mobile">
                                </b-form-input>
                            <!-- </b-input-group> -->
                        </b-form-group>
                        <b-form-group id="emailGroup"
                            label="Email Address"
                            label-for="email"
                            class="secondary-label mb-3 sl-helper"
                            :invalid-feedback="errorMessage('email')"
                            :state="isValid('email')">
                            <b-form-input id="email"
                                type="email"
                                required
                                v-model="store.email">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group id="branchGroup"
                            label="Branch Address"
                            label-for="branchadd"
                            class="secondary-label mb-3 sl-helper"
                            :invalid-feedback="errorMessage('branch_address')"
                            :state="isValid('branch_address')">
                            <b-form-textarea
                                id="branchadd"
                                rows="4"
                                max-rows="4"
                                v-model="store.branch_address"
                                />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col>
                        <hr class="form-divider">
                    </b-col>
                </b-row>
                <b-row no-gutters>
                    <b-col sm="12" md="3">
                        <h6 class="main-label">Google Map</h6>
                    </b-col>
                    <b-col>
                        <div id="gmap" style="width: 100%; height: 300px;"></div>
                        <input type="text" class="form-control mb-3" id="gmap-search" v-model="store.search">
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col>
                        <hr class="form-divider">
                    </b-col>
                </b-row>
                <b-row no-gutters>
                    <b-col sm="12" md="3">
                        <h6 class="main-label">Visibility</h6>
                    </b-col>
                    <b-col>
                        <b-form-group
                            label="Publish in App"
                            label-for="visibility" class="secondary-label mb-3">
                            <switches
                                theme="custom"
                                color="primary"
                                type-bold="true"
                                style="top: 15px;"
                                v-model="store.visibility">
                            </switches>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <div slot="modal-footer">
                <b-button
                    variant="ghost"
                    class="btn-cancel"
                    style="margin-right: .25rem;"
                    @click="cancelAddStore">
                    Cancel
                </b-button>
                <b-button
                    variant="primary"
                    style="margin-left: .25rem;"
                    @click="submit">
                    Save
                </b-button>
            </div>
        </b-modal>
        <LogoCroppa
            :open="store.croppa"
            :openType="store.mode"
            @openAddStore="closeCroppa"
            @croppaLogo="setLogo">
        </LogoCroppa>
    </div>
</template>

<script>
import { mapState } from "vuex";

import Switches from "vue-switches";
import gmap from "google-maps";
import LogoCroppa from "./LogoCroppa";
import SingleDatepicker from "vuejs-datepicker";

gmap.KEY = "AIzaSyBZv6XyeHm4hdS2GyBTRwLZMgUAXv8k-JE";
gmap.VERSION = "3.34";
gmap.LIBRARIES = ["geometry", "places"];

gmap.load(function(library) {
    window.google = library;
});
export default {
    name: "CustomerAddNewStore",
    props: [
        "open"
    ],
    components: {
        Switches,
        LogoCroppa,
        SingleDatepicker
    },
    data() {
        return {
            store: {
                name: "",
                type: "",
                tier: "",
                image: "",
                mobile: null,
                email: null,
                branch_address: "",
                search: "",
                visibility: true,
                currentPosition: {
                    lat: 14.599512,
                    long: 120.984222
                },
                croppa: false,
                mode: null,
                retailer_since: new Date(),
                isr_code: null,
                latitude: 14.599512,
                longitude: 120.984222,
            },
            disabledDates: {
                from: new Date(Date.now() - 8640000)
            }
        }
    },
    computed: {
        ...mapState("customers", ["uuid"]),
        ...mapState("reportsStores", ["membership_id", "errors", "param", "owner"]),
    },
    mounted() {
        this.geolocate();
    },
    methods: {
        cancelAddStore: async function() {
            if(this.store.croppa !== true) {
                this.store.name = "";
                this.store.type = "";
                this.store.tier = "";
                this.store.isr_code = null;
                this.store.image = "";
                this.store.mobile = null;
                this.store.email = null;
                this.store.mobile = null;
                this.store.branch_address = "";
                this.store.search = "";
                this.store.visibility = false;
                this.store.retailer_since = new Date();
                this.$emit("cancelAddStore");
                this.store_owner = null;
            }
            this.$store.commit("reportsStores/setModal", {
                type: "new",
                status: false
            });
        },

        submit: async function() {
            let param = {
                membership_id: this.membership_id,
                isr_code: this.store.isr_code,
                store_name: this.store.name,
                store_type: this.store.type,
                tier: this.store.tier,
                store_image: this.store.image.slice(22),
                phone: this.store.mobile ? this.store.mobile : null,
                email: this.store.email,
                branch_address: this.store.branch_address,
                lat: this.store.latitude,
                lng: this.store.longitude,
                visibility: this.store.visibility,
                retailer_since: this.$moment(this.store.retailer_since)
                    .format("YYYY-MM-DD"),
                store_owner: this.owner
            }

            await this.$store.dispatch("reportsStores/create", param)
                .then(() => {
                    if (this.errors == null) {
                        this.$store.dispatch("reportsStores/getList", {
                            membership_id: this.membership_id,
                            page: this.param.page
                        });
                        this.$store.commit("reportsStores/setModal", {
                            type: "new",
                            status: false
                        });
                        this.$refs.AddStore.hide();
                    }
                });

            // console.log({
            //     saving: param
            // });
        },

        geolocate: function() {
            navigator.geolocation.getCurrentPosition(position => {
                this.store.currentPosition = {
                    lat: position.coords.latitude,
                    long: position.coords.longitude
                };
            });
        },

        // GOOGLE MAP FIELD //
        renderMap(lat = null, long = null) {
            let self = this;
            let google = window.google;
            let map = new google.maps.Map(document.getElementById("gmap"), {
                center: {
                    lat: lat ? lat : this.store.currentPosition.lat || 14.599512,
                    lng: long ? long : this.store.currentPosition.long || 120.984222
                },
                zoom: 11
            });
            let marker = new google.maps.Marker({
                position: {
                    lat: lat ? lat : 14.599512,
                    lng: long ? long : 120.984222
                },
                map: map,
                draggable: true
            });

            marker.addListener("dragend", () => {
                self.store.latitude = marker.getPosition().lat();
                self.store.longitude = marker.getPosition().lng();
            });

            let searchBox = new google.maps.places.SearchBox(
                document.getElementById("gmap-search")
            );

            google.maps.event.addListener(searchBox, "places_changed", () => {
                let places = searchBox.getPlaces();
                if (places.length == 0) return;

                let bounds = new google.maps.LatLngBounds();
                let place = places[0];

                bounds.extend(place.geometry.location);
                marker.setPosition(place.geometry.location);

                self.store.latitude = place.geometry.location.lat();
                self.store.longitude = place.geometry.location.lng();

                map.fitBounds(bounds);
                map.setZoom(17);
            });
        },

        getmap: async function() {
            await this.renderMap();
        },

        openCalendar(type) {
            let calendar = "datepicker_" + type;
            this.$refs[calendar].showCalendar();
        },

        uploadLogo: async function(type) {
            this.store.mode = type;
            this.store.croppa = await true;
            this.$refs.AddStore.hide();
        },

        closeCroppa: function() {
            this.store.croppa = false;
            this.$refs.AddStore.show();
        },

        setLogo: function(image) {
            this.store.image = image;
        },

        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors[field];
        },

        isValid(field) {
            if (this.errors == null) {
                return false;
            }

            return this.errors[field] ? false : true;
        }
    },
    watch: {
        open: async function(value) {
            if(value === true) {
                this.$refs.AddStore.show();
            } else {
                await this.$store.commit("reportsStores/clearErrors", null);
                this.$refs.AddStore.hide();
            }
        }
    }
}
</script>
